<div *ngIf="certificateType=='1'">
    <calsoft-certificate-no1  [imageUrl]="serverPath" [data]="data" ></calsoft-certificate-no1>
</div>
<div *ngIf="certificateType=='2'">
    <calsoft-certificate-no2  [imageUrl]="serverPath" [data]="data" ></calsoft-certificate-no2>
</div>

<div>
    <button mat-raised-button (click)="generate()"> Download
    </button>
</div>